import { useEffect, useState } from 'react'
import { useAuth } from '@structural-climbing/auth'
import { PlansSection } from '../features/plans/PlansSection'
import type { GymPlan } from '../features/plans/types'

export function PlansPage() {
  const { getAccessTokenSilently } = useAuth()
  const apiUrl = import.meta.env.VITE_API_URL as string

  const [plans, setPlans] = useState<GymPlan[]>([])
  const [plansLoading, setPlansLoading] = useState(true)

  async function loadPlans() {
    setPlansLoading(true)
    try {
      const token = await getAccessTokenSilently()
      const res = await fetch(`${apiUrl}/gym-plans`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (res.ok) setPlans((await res.json()) as GymPlan[])
    } finally {
      setPlansLoading(false)
    }
  }

  useEffect(() => {
    void loadPlans()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="p-4 sm:p-8">
      <PlansSection plans={plans} loading={plansLoading} onRefresh={() => void loadPlans()} />
    </div>
  )
}
